import { render } from "./DiscussionsView.vue?vue&type=template&id=ba30c00e"
import script from "./DiscussionsView.vue?vue&type=script&lang=js"
export * from "./DiscussionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__